import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sumArrayFieldPipe'
})
export class SumArrayFieldPipePipe implements PipeTransform {

  transform(items: any[], attr: string): any {

    if ( attr === 'prestado' ) {
      let prestado:number=0;

      for (let row of items) {
          prestado = prestado + Number(row['MONTO_PRESTAMO']);
      }

      return prestado;

    }



    if ( attr === 'montoCuotas' ) {

      let cuotaMontos:number=0;

      for (let row of items) {
          cuotaMontos = cuotaMontos + Number(row['MONTO_CUOTA']);
      }
      return cuotaMontos;

    }



  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/pipes/sum-array-field-pipe.pipe.ts